export function dispatchOperatorAction(actionId, payload = {}) {
  window.dispatchEvent(new CustomEvent(actionId, { detail: payload }));
}

export const operatorConfig = {
  days: [
    { id: "GLOBAL", label: "سراسری" },
    { id: "Day-1", label: "روز ۱" },
    { id: "Day-2", label: "روز ۲ ـ پرسش و پاسخ" },
    { id: "Day-3", label: "روز ۳" },
    { id: "Day-4", label: "روز ۴" },
    { id: "Day-5", label: "روز ۵" },
    { id: "Day-6", label: "روز ۶" },
    { id: "Day-7", label: "روز ۷" },
    { id: "Day-8", label: "روز ۸" },
    { id: "Day-9", label: "روز ۹" },
    { id: "Day-10", label: "روز ۱۰" },
    { id: "Day-11", label: "روز ۱۱" },
    { id: "Day-12", label: "روز ۱۲" },
  ],
  actions: {
    GLOBAL: [
      { id: "SHOW_INTRO", label: "نمایش مقدمهٔ برنامه" },

      { id: "SHOW_DESCRIPTION", label: "نمایش توضیحات" },
      {
        id: "SHOW_HEARTBEAT",
        label: "نمایش شمارش معکوس (HeartBeat)",
        payloadSchema: {
          fields: [
            {
              name: "countFrom",
              label: "شروع شمارش از",
              type: "number",
              required: true,
              default: 3,
              min: 1,
            },
            {
              name: "autoStartTimer",
              label: "پس از پایان شمارش، تایمر به‌صورت خودکار شروع شود",
              type: "checkbox",
              required: false,
            },
          ],
        },
      },
      {
        id: "TRIGGER_CHALLENGE_FLOW",
        label: "اجرای فلو کامل چالش (Challenge Flow)",
        payloadSchema: {
          fields: [
            {
              name: "title",
              label: "عنوان چالش",
              type: "text",
              required: true,
            },
            {
              name: "description",
              label: "توضیحات چالش",
              type: "textarea",
              required: false,
            },
            {
              name: "enableHeartbeat",
              label: "آیا HeartBeat فعال باشد؟",
              type: "checkbox",
            },
            {
              name: "countFrom",
              label: "شمارش از چند؟ (اگر فعال است)",
              type: "number",
              required: false,
              default: 3,
              min: 1,
            },
            {
              name: "autoStartTimer",
              label: "شروع خودکار تایمر بعد از HeartBeat",
              type: "checkbox",
            },
            {
              name: "timerDuration",
              label: "مدت‌زمان تایمر (ثانیه)",
              type: "number",
              required: false,
            },
            {
              name: "reverse",
              label: "پر شدن معکوس تایمر؟",
              type: "checkbox",
              required: false,
            },
          ],
        },
      },

      {
        id: "SHOW_LOGO_5K",
        label: "نمایش لگو 5k",
        payloadSchema: {
          loop: true,
          isLoopState: false,
          label: "lopp",
          type: "boolean",
        },
      },
      {
        id: "SHOW_LOGO_10K",
        label: "نمایش لگو 10K",
        payloadSchema: {
          loop: true,
          isLoopState: false,
          label: "lopp",
          type: "boolean",
        },
      },

      {
        id: "SHOW_LOGO_CLOSE_ALL_POSITION",
        label: "نمایش لگو close all position",
        payloadSchema: {
          loop: true,
          isLoopState: false,
          label: "lopp",
          type: "boolean",
        },
      },
      {
        id: "SHOW_LOGO_GOLDEN_BUZZER",
        label: "نمایش لگو Golden Buzzer",
        payloadSchema: {
          loop: true,
          isLoopState: false,
          label: "lopp",
          type: "boolean",
        },
      },
      {
        id: "SHOW_LOGO_WINNER",
        label: "نمایش لگو WINNER",
        payloadSchema: {
          loop: true,
          isLoopState: false,
          label: "lopp",
          type: "boolean",
        },
      },
      {
        id: "SHOW_LOGO_AHANGRAY_HOLDING_1",
        label: "نمایش لگو آهنگری هلدینگ MMMMM",
        payloadSchema: {
          loop: true,
          isLoopState: false,
          label: "lopp",
          type: "boolean",
        },
      },
      {
        id: "SHOW_LOGO_IRON_BEAR",
        label: "نمایش لگو خرس آهنی MMMMM",
        payloadSchema: {
          loop: true,
          isLoopState: false,
          label: "lopp",
          type: "boolean",
        },
      },
      {
        id: "SHOW_LOGO_GOLDEN_EAGLES",
        label: "نمایش لگو عقاب طلایی MMMMM",
        payloadSchema: {
          loop: true,
          isLoopState: false,
          label: "lopp",
          type: "boolean",
        },
      },
      {
        id: "SHOW_LOGO_FENEFX",
        label: "نمایش لگو فنفیکس MMMMM",
        payloadSchema: {
          loop: true,
          isLoopState: false,
          label: "lopp",
          type: "boolean",
        },
      },
      {
        id: "SHOW_LOGO_BULL_MASTERS",
        label: "نمایش لگو Bull Masters MMMMM",
        payloadSchema: {
          loop: true,
          isLoopState: false,
          label: "lopp",
          type: "boolean",
        },
      },
      {
        id: "SHOW_LOGO_ALPHA_WOLVES",
        label: "نمایش لگو Alpha Wolves MMMMM",
        payloadSchema: {
          loop: true,
          isLoopState: false,
          label: "lopp",
          type: "boolean",
        },
      },
      {
        id: "SHOW_LOGO_HOUSE_OF_TRADERS",
        label: "نمایش لگو HOUSE OF TRADERS MMMMM",
        payloadSchema: {
          loop: true,
          isLoopState: false,
          label: "lopp",
          type: "boolean",
        },
      },
      {
        id: "SHOW_LOGO_MOND_FINE",
        label: "نمایش لگو موند فاین MMMMM",
        payloadSchema: {
          loop: true,
          isLoopState: false,
          label: "lopp",
          type: "boolean",
        },
      },
      { id: "SHOW_DESCRIPTION", label: "نمایش توضیحات" },
      { id: "SHOW_AHANGARI_HOLDING", label: "نمایش لوگوی هلدینگ آهنگری" },
      { id: "SHOW_HOT_LOGO", label: "نمایش لوگوی House of Traders" },
      { id: "SHOW_MOND_LOGO", label: "نمایش لوگوی MondFX" },
      { id: "SHOW_FENE_LOGO", label: "نمایش لوگوی FeneFX" },
      { id: "SHOW_TABLE", label: "نمایش جدول چالش‌های قبلی" },
      { id: "SHOW_TABLE_Final", label: "نمایش جدول نهایی" },
      { id: "SHOW_TABLE_Realtime", label: "نمایش جدول لحظه‌ای" },
      { id: "SHOW_TEAM_TABLE", label: "نمایش جدول تیم‌ها" },
      { id: "SHOW_IFRAME", label: "نمایش آی فریم" },
      { id: "SHOW_TRANSFORM_MARKET", label: "نمایش Transform Market" },
      {
        id: "SHOW_TRANSFORM_MARKET_TABLE",
        label: "نمایش Transform Market Table",
      },
      { id: "SHOW_TIMER", label: "نمایش تایمر" },
      {
        id: "SHOW_USER_PANEL",
        label: "نمایش پنل کاربر",
        payloadSchema: {
          name: "login",
          label: "شناسهٔ کاربر",
          type: "number",
          required: true,
        },
      },
      {
        id: "SHOW_HEARTBEAT",
        label: "نمایش شمارش معکوس (HeartBeat)",
        payloadSchema: {
          fields: [
            {
              name: "countFrom",
              label: "شروع شمارش از",
              type: "number",
              required: true,
              default: 3,
              min: 1,
            },
            {
              name: "autoStartTimer",
              label: "پس از پایان شمارش، تایمر به‌صورت خودکار شروع شود",
              type: "checkbox",
              required: false,
            },
          ],
        },
      },
      {
        id: "TRIGGER_CHALLENGE_FLOW",
        label: "اجرای فلو کامل چالش (Challenge Flow)",
        payloadSchema: {
          fields: [
            {
              name: "title",
              label: "عنوان چالش",
              type: "text",
              required: true,
            },
            {
              name: "description",
              label: "توضیحات چالش",
              type: "textarea",
              required: false,
            },
            {
              name: "enableHeartbeat",
              label: "آیا HeartBeat فعال باشد؟",
              type: "checkbox",
            },
            {
              name: "countFrom",
              label: "شمارش از چند؟ (اگر فعال است)",
              type: "number",
              required: false,
              default: 3,
              min: 1,
            },
            {
              name: "autoStartTimer",
              label: "شروع خودکار تایمر بعد از HeartBeat",
              type: "checkbox",
            },
            {
              name: "timerDuration",
              label: "مدت‌زمان تایمر (ثانیه)",
              type: "number",
              required: false,
            },
            {
              name: "reverse",
              label: "پر شدن معکوس تایمر؟",
              type: "checkbox",
              required: false,
            },
          ],
        },
      },
      { id: "SHOW_ALL_CAPTAINS", label: "نمایش 4 کپتن " },
    ],
    day1: [
      { id: "SHOW_INTRO", label: "نمایش مقدمهٔ برنامه" },
      {
        id: "SHOW_CHALLENGES",
        label: "چالش ها",
        payloadSchema: {
          fields: [
            {
              name: "title",
              label: "عنوان چالش",
              type: "text",
              required: true,
            },
          ],
        },
      },
      { id: "SHOW_AHANGARI_HOLDING", label: "نمایش لوگوی هلدینگ آهنگری" },
      { id: "SHOW_HOT_LOGO", label: "نمایش لوگوی House of Traders" },
      { id: "SHOW_MOND_LOGO", label: "نمایش لوگوی MondFX" },
      { id: "SHOW_FENE_LOGO", label: "نمایش لوگوی FeneFX" },
      { id: "SHOW_TABLE", label: "نمایش جدول چالش‌های قبلی" },
      { id: "SHOW_TABLE_Realtime", label: "نمایش جدول لحظه‌ای" },
      { id: "SHOW_TABLE_Final", label: "نمایش جدول نهایی" },
      { id: "SHOW_ALL_CAPTAINS", label: "نمایش 4 کپتن " },
    ],
    day2: [
      { id: "SHOW_INTRO", label: "نمایش مقدمهٔ " },
      { id: "DAY2_SHOW_QUESTIONS", label: "نمایش سؤال‌ها" },
      { id: "DAY2_MARK_QUESTION", label: "علامت‌گذاری سؤال" },
      {
        id: "SET_SELECTED_QUESTION",
        label: "انتخاب سؤال",
        payloadSchema: {
          fields: [
            {
              name: "id",
              label: "شناسهٔ سؤال",
              type: "number",
              required: true,
            },
          ],
        },
      },
      { id: "DAY2_REVEAL_QUESTION", label: "آشکار کردن سؤال" },
      {
        id: "DAY2_MARK_ANSWER",
        label: "علامت‌گذاری پاسخ",
        payloadSchema: {
          fields: [
            {
              name: "questionId",
              label: "شناسهٔ سؤال",
              type: "number",
              required: true,
            },
            {
              name: "answerId",
              label: "شناسهٔ پاسخ",
              type: "number",
              required: true,
            },
          ],
        },
      },
      {
        id: "DAY2_SELECT_ANSWER",
        label: "ثبت پاسخ (قفل)",
        payloadSchema: {
          fields: [
            {
              name: "questionId",
              label: "شناسهٔ سؤال",
              type: "number",
              required: true,
            },
            {
              name: "answerId",
              label: "شناسهٔ پاسخ",
              type: "number",
              required: true,
            },
          ],
        },
      },
      { id: "DAY2_REVEAL_RESULTS", label: "نمایش نتایج" },
      { id: "DAY2_RESET", label: "بازنشانی روز ۲" },
      {
        id: "SHOW_QUESTIONS_RESULT_TABLE",
        label: "نمایش جدول نتایج سؤال‌ها",
      },
      { id: "SHOW_CAPTAINS_DRAFT", label: "نمایش قرعه‌کشی کاپیتان‌ها" },
      { id: "SHOW_IRONBEARS", label: "نمایش تیم IronBears" },
      { id: "SHOW_BULLMASTERS", label: "نمایش تیم BullMasters" },
      { id: "SHOW_ALPHAWOLVES", label: "نمایش تیم AlphaWolves" },
      { id: "SHOW_GOLDENEAGLES", label: "نمایش تیم GoldenEagles" },
      { id: "SHOW_BOX", label: "نمایش صندوق" },
    ],
    day3: [
      { id: "SHOW_INTRO", label: "نمایش مقدمهٔ " },

      { id: "SHOW_TEAM_TABLE", label: "نمایش جدول تیم‌ها" },
      { id: "SHOW_BULLMASTERS_REALTIME", label: "نمایش لحظه‌ای BullMasters" },
      { id: "SHOW_ALPHAWOLVES_REALTIME", label: "نمایش لحظه‌ای AlphaWolves" },
      { id: "SHOW_GOLDENEAGLES_REALTIME", label: "نمایش لحظه‌ای GoldenEagles" },
      { id: "SHOW_IRONBEARS_REALTIME", label: "نمایش لحظه‌ای IronBears" },
      { id: "SHOW_TEAM_PROFIT_TABLE", label: "نمایش جدول سود تیم‌ها" },
    ],
    day4: [
      { id: "SHOW_INTRO", label: "نمایش مقدمهٔ " },

      {
        id: "IRONBEARS_GOLDENEAGLES",
        label: "IronBears در برابر GoldenEagles",
      },
      { id: "IRONBEARS_BULLMASTERS", label: "IronBears در برابر BullMasters" },
      { id: "IRONBEARS_ALPHAWOLVES", label: "IronBears در برابر AlphaWolves" },
      {
        id: "GOLDEN_EAGLES_ALPHAWOLVES",
        label: "GoldenEagles در برابر AlphaWolves",
      },
      {
        id: "GOLDEN_EAGLES_BULLMASTERS",
        label: "GoldenEagles در برابر BullMasters",
      },
      {
        id: "BULLMASTERS_ALPHAWOLVES",
        label: "BullMasters در برابر AlphaWolves",
      },
    ],
    day5: [{ id: "SHOW_TEAMS", label: "نمایش رده تیم‌ها" }],
    day6: [
      { id: "DAY6_SHOW_PANEL", label: "نمایش پنل پنالتی" },
      { id: "DAY6_HIDE_PANEL", label: "مخفی کردن پنل پنالتی" },

      {
        id: "DAY6_SET_PAIR",
        label: "تنظیم تیم‌ها (بدون ترتیب)",
        payloadSchema: {
          fields: [
            {
              name: "teams",
              label: "تیم‌ها",
              type: "array",
              required: true,
              help: "کلید دو تیم به هر ترتیب",
              options: [
                "ironbears",
                "alphawolves",
                "bullmasters",
                "goldeneagles",
              ],
              minLength: 2,
              maxLength: 2,
            },
          ],
        },
      },

      {
        id: "DAY6_SET_SYMBOL",
        label: "تنظیم نماد",
        payloadSchema: {
          fields: [
            {
              name: "symbol",
              label: "نماد",
              type: "text",
              required: true,
              placeholder: "مثلاً BTCUSDT",
            },
          ],
        },
      },

      {
        id: "DAY6_SET_MAX_SCORE",
        label: "تنظیم حداکثر اسلات امتیاز",
        payloadSchema: {
          fields: [
            {
              name: "max",
              label: "حداکثر تعداد",
              type: "number",
              required: true,
              min: 1,
              max: 10,
            },
          ],
        },
      },

      {
        id: "DAY6_SET_SCORE",
        label: "همگام‌سازی امتیاز (مطلق)",
        payloadSchema: {
          fields: [
            {
              name: "left",
              label: "امتیاز چپ",
              type: "number",
              required: true,
              min: 0,
              max: 10,
            },
            {
              name: "right",
              label: "امتیاز راست",
              type: "number",
              required: true,
              min: 0,
              max: 10,
            },
          ],
        },
      },

      {
        id: "DAY6_GOAL",
        label: "گل (+۱)",
        payloadSchema: {
          fields: [
            {
              name: "side",
              label: "سمت",
              type: "select",
              required: true,
              options: ["left", "right"],
            },
          ],
        },
      },

      {
        id: "DAY6_MISS",
        label: "از دست‌رفته (بدون امتیاز)",
        payloadSchema: {
          fields: [
            {
              name: "side",
              label: "سمت",
              type: "select",
              required: true,
              options: ["left", "right"],
            },
          ],
        },
      },

      { id: "DAY6_UNDO_LAST", label: "برگرداندن آخرین مورد" },
      { id: "DAY6_RESET", label: "بازنشانی امتیازها" },
    ],
    day7: [{ id: "SHOW_CAPTAIN_VS_TEAM", label: "نمایش پنل پنالتی" }],
  },
};
